import { render, staticRenderFns } from "./SearchBarWrapper.vue?vue&type=template&id=0fe74c02&scoped=true&"
import script from "./SearchBarWrapper.vue?vue&type=script&lang=js&"
export * from "./SearchBarWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe74c02",
  null
  
)

export default component.exports